<template>
    <common-panel
            v-model="value"
            :image="image"
            :is-read-only="readOnly"
            :width-style="widthStyle"
            :related-url="relatedUrl"
            :validation-lists="validationLists"
            :translate-obj="translateObj"
            :element-author-display="elementAuthorDisplay"
            @close="closePanel"
            @changeTranslate="changeTranslate"
    >
        <template v-if="AggregateRulePanelStatus" slot="root">
            <aggregate-rules-panel :copy-value="value"  :givenItems="givenItems" :attachedPolicies="attachedPolicies" @close="closePanel" @left="left"></aggregate-rules-panel>
        </template>

        <template slot="t-description-text">
            비즈니스 로직 처리의 도메인 객체 덩어리 (서로 연결된 하나 이상의 엔터티 및 value objects의 집합체)
        </template>

        <template slot="t-generation-text">
            Aggregate becomes the main body of software implementation - Domain Classes.
        </template>


        <template slot="t-edit-user">
            <div
                    v-if="newEditUserImg.length > 0 && readOnly"
                    style="text-align:center"
            >
                <v-chip
                        small
                        color="orange"
                        text-color="white"
                        style="font-weight:bold">
                    <v-avatar left>
                        <v-icon>mdi-lead-pencil</v-icon>
                    </v-avatar>
                    {{newEditUserImg[0].name}} is now editing...
                </v-chip>
            </div>
        </template>



        <template slot="md-title-side">
            <v-btn
                    text
                    color="primary"
                    style="margin-left: 10px; margin-top: -12px;"
                    @click="changeAggregateRulePanelStatus()"
                    :disabled="readOnly"
            >Rules</v-btn>
        </template>

        <template slot="element">
            <div>
                <v-card flat>
                    <v-card-text>
                        <event-storming-attribute
                                v-model="value.aggregateRoot.fieldDescriptors"
                                :isReadOnly="readOnly"
                                :type="value._type"
                                :elementId="value.elementView.id"
                                :entities="value.aggregateRoot.entities"
                                @open-umlclass="openClassDiagram"
                        ></event-storming-attribute>
                    </v-card-text>
                </v-card>
            </div>
        </template>

    </common-panel>

</template>


<script>
    import CommonPanel from "./CommonPanel";
    import EventStormingModelPanel from "../EventStormingModelPanel";
    import AggregateRulesPanel from "../panels/AggregateDefinitionRulesPanel";

    // Translate
    var googleTranslate = require('google-translate')(process.env.VUE_APP_TRANSLATE_KEY);
    var changeCase = require('change-case');
    var jsondiffpatch = require('jsondiffpatch').create({
        objectHash: function (obj, index) {
            return '$$index:' + index;
        },
    });

    export default {
        mixins: [EventStormingModelPanel],
        name: 'aggregate-panel',
        components: {
            AggregateRulesPanel,
            CommonPanel
        },
        computed: {

        },
        created: function () {
            this.panelInit()
        },
        data() {
            return {
                AggregateRulePanelStatus: false,
                attachedPolicies : {},
                givenItems:[],
                ruleValues: {
                    ruleName: null,
                    whenItems: [],
                    thenItems: [],
                    givenValue: null,
                    whenValue: null,
                    thenValue: null,
                    show: false,
                    editMode: false,
                    attributes: []
                },
                ruleAttribute: {
                    givenAtt: {
                        attKey: [],
                        attValue: [],
                    },
                    aggregateAtt: {
                        attKey: [],
                        attValue: [],
                    },
                    thenAtt: {
                        attKey: [],
                        attValue: [],
                    },
                },
                // UML Class
                aggregateRoots: [],
            }
        },
        mounted() {
            var me = this
        },
        watch: {},
        methods: {
            panelInit(){
                var me = this
                // Element
                me.relatedUrl = 'https://intro-kor.msaez.io/tool/event-storming-tool/#%C2%B7-aggregate-sticker'
                me.setRootMethods();

                // Common
                me.$super(EventStormingModelPanel).panelInit()
            },
            setEntityTypeList() {
                var me = this
                if (me.value.aggregateRoot.entities == undefined) {
                    return false
                }

                me.entityTypeList = [
                    {text: 'Primitive Types', disabled: true},
                    {text: 'Integer', value: 'Integer'},
                    {text: 'String', value: 'String'},
                    {text: 'Boolean', value: 'Boolean'},
                    {text: 'Float', value: 'Float'},
                    {text: 'Double', value: 'Double'},
                    {text: 'Long', value: 'Long'},
                    {text: 'Date', value: 'Date'},
                ]

                if (Object.values(me.value.aggregateRoot.entities.elements).length > 1) {
                    me.entityTypeList.push({text: 'Complex Types', disabled: true})
                    Object.values(me.value.aggregateRoot.entities.elements).forEach(function (item) {
                        if (item) {
                            if (item.name != me.value.name) {
                                me.entityTypeList.push({text: item.name, value: item.name})
                            }
                        }
                    })
                }
            },
            left(){
                var me = this
                me.AggregateRulePanelStatus = !me.AggregateRulePanelStatus
            },
            changeAggregateRulePanelStatus() {
                var me = this
                var attachedPolicies = {} // agg에 붙어있는 폴리시들
                if (Object.values(me.canvasbase.attachedLists.policyLists).length > 0) {
                    Object.values(me.canvasbase.attachedLists.policyLists).forEach(function (policy, idx) {
                        var outer = {
                            x: (policy.elementView.x - policy.elementView.width / 2) - 10,
                            y: (policy.elementView.y - policy.elementView.height / 2) - 10,
                            width: policy.elementView.width + 20,
                            height: policy.elementView.height + 20
                        }

                        var inner = {
                            x: me.value.elementView.x - me.value.elementView.width / 2,
                            y: me.value.elementView.y - me.value.elementView.height / 2,
                            width: me.value.elementView.width,
                            height: me.value.elementView.height
                        }

                        if (me.canvasbase._isAttached(outer, inner)) {
                            attachedPolicies[policy.elementView.id] = policy;
                        }
                    })
                }
                var incomingEvent = [] // 붙어 있는 폴리스들과 연결 되어 있는 외부 event
                if (Object.values(me.canvasbase.value.relations).length > 0) {
                    Object.values(me.canvasbase.value.relations).forEach(function (rel, idx) {
                        if (rel && rel._type.endsWith('Relation')) {
                            if (rel.sourceElement._type.endsWith('Event') && rel.targetElement._type.endsWith('Policy')) {
                                if (attachedPolicies[rel.targetElement.elementView.id]) {
                                    incomingEvent.push(rel.sourceElement);
                                }
                            }
                        }
                    })
                }

                me.givenItems = incomingEvent
                me.attachedPolicies = attachedPolicies
                // me.copyValue.givenItems = me.givenItems

                me.AggregateRulePanelStatus = !me.AggregateRulePanelStatus

            },
            openClassDiagram() {
                var me = this
                if (me.value.aggregateRoot.entities == undefined) {
                    me.value.aggregateRoot['entities'] = {'elements': {}, 'relations': {}}
                }
                me.setRootMethods();
                
                Object.values(me.canvasbase.value.elements).forEach(function (item) {
                    if (item) {
                        if (item._type == "org.uengine.modeling.model.Aggregate" && item.boundedContext.id == me.value.boundedContext.id) {
                            me.aggregateRoots.push(item);
                        }
                    }
                })

                var umlValue = {
                    type: 'Domain Class Modeling',
                    aggId: me.value.elementView.id,
                    aggList: me.aggregateRoots
                };
                me.canvasbase.overlayText = 'Loading';
                me.canvasbase.openEmbeddedCanvas(umlValue);
                me.closePanel();
            },
            setRootMethods() {
                var me = this;

                Object.values(me.canvasbase.value.elements).forEach((element) => {
                    if (element && element.elementView && element._type.endsWith("Command")) {
                        var outer = {
                            x: me.value.elementView.x - me.value.elementView.width / 2,
                            y: me.value.elementView.y - me.value.elementView.height / 2,
                            width: me.value.elementView.width,
                            height: me.value.elementView.height
                        }
                        var inner = {
                            x: element.elementView.x - element.elementView.width / 2,
                            y: element.elementView.y - element.elementView.height / 2,
                            width: element.elementView.width,
                            height: element.elementView.height
                        }

                        if (me.canvasbase._isAttached(outer, inner)) {
                            if(!element.isRestRepository) {
                                var method = {
                                    "name": element.name,
                                    "class": me.value.name,
                                    "returnType": "void",
                                    "parameters": [],
                                    "label": '+ ' + element.name + "(): void",
                                    "isOverride": false,
                                    "isRootMethod": false,
                                }
                                if(me.value.aggregateRoot.operations.length > 0) {
                                    me.value.aggregateRoot.operations.forEach(function(item, idx) {
                                        if(item.name == method.name) {
                                            item.isRootMethod = true
                                            method.isRootMethod = true
                                        }
                                    })
                                    if(!method.isRootMethod) {
                                        method.isRootMethod = true
                                        me.value.aggregateRoot.operations.push(method)
                                    }
                                } else {
                                    me.value.aggregateRoot.operations.push(method)
                                }
                            }
                        }
                    }
                })
                // me.copyValue = me.value;
            },
            selectKey(item) {
                var me = this

                me.value.aggregateRoot.fieldDescriptors.forEach(function (ele, idx) {
                    if (idx == me.value.aggregateRoot.fieldDescriptors.indexOf(item)) {
                        ele.isKey = item.isKey
                    } else {
                        ele.isKey = false
                    }
                })

            },

            async changedNamePanel(newVal){
                var me = this
                me.value.name = newVal.replace(/\n/g, "").replace(/ /gi, "")
                me.canvasbase.$refs[`${me.value.elementView.id}`][0].namePanel = me.value.name

                var translateObj = await me.getTranslate(me.value.name);
                me.usedTranslate = translateObj.usedTranslate
                me.translateText = translateObj.translateText
            },
            getTranslate(newVal){
                try{
                    return new Promise(async function (resolve) {
                        googleTranslate.detectLanguage(newVal, function (err, detection) {
                            if (detection.language != 'en') {
                                googleTranslate.translate(newVal, 'en', function (err, translation) {
                                    var obj={
                                        'usedTranslate' : true,
                                        'translateText' : changeCase.pascalCase(translation.translatedText)
                                    }
                                    resolve(obj)
                                });
                            } else if (detection.language == 'en') {
                                var obj={
                                    'usedTranslate' : true,
                                    'translateText' : changeCase.pascalCase(newVal)
                                }
                                resolve(obj)
                            }
                        });
                    })
                }catch (e) {
                    return undefined;
                }
            },
        }
    }
</script>
